import Header from '../components/common/header';
import {
  FiZap,
  FiCpu,
  FiTrendingUp,
  FiGitBranch,
  FiActivity
} from 'react-icons/fi';

export default function SignalAnatomyPage() {
  return (
    <>
      <Header />

      <div
        style={{
          maxWidth: '1100px',
          margin: '0 auto',
          padding: '72px 24px',
        }}
      >
        {/* HERO */}
        <h1
          style={{
            marginBottom: '12px',
            color: 'var(--primary)',
            fontSize: '40px',
            fontWeight: 700,
          }}
        >
          Signal Anatomy
        </h1>

        <p
          style={{
            color: 'var(--grey)',
            fontSize: '16px',
            maxWidth: '720px',
            lineHeight: 1.6,
          }}
        >
          A high-level overview of how raw mempool and block data is transformed
          into structured, actionable on-chain signals.
        </p>

        {/* GRID */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
            gap: '24px',
            marginTop: '56px',
          }}
        >
          <SignalCard
            icon={<FiZap />}
            title="Gas Spike Detection"
            category="Network Stress"
            description="Detects abnormal gas fee surges that often precede MEV activity,
            liquidations, or priority execution strategies."
          />

          <SignalCard
            icon={<FiGitBranch />}
            title="First Token Activity"
            category="Early Lifecycle"
            description="Identifies the very first on-chain interactions of newly deployed
            tokens before public discovery or listings."
          />

          <SignalCard
            icon={<FiCpu />}
            title="Bot-like Transactions"
            category="Behavior Analysis"
            description="Classifies deterministic transaction patterns typical for
            automated strategies, MEV bots, and arbitrage systems."
          />

          <SignalCard
            icon={<FiTrendingUp />}
            title="Real Swap Detection"
            category="Liquidity Flow"
            description="Separates meaningful token swaps from noise, approvals,
            internal contract logic, and synthetic activity."
          />

          <SignalCard
            icon={<FiActivity />}
            title="Zero-Value Logic Calls"
            category="Smart Contract Logic"
            description="Tracks complex contract interactions without value transfer,
            often linked to setup phases or exploit patterns."
          />
        </div>

        {/* FOOTNOTE */}
        <p
          style={{
            marginTop: '56px',
            fontSize: '13px',
            color: 'var(--grey)',
            opacity: 0.7,
          }}
        >
          Signals shown here are derived from live production infrastructure and
          continuously refined.
        </p>
      </div>
    </>
  );
}

function SignalCard({ icon, title, category, description }) {
  return (
    <div
      style={{
        background: 'var(--black)',
        border: '1px solid #222',
        borderRadius: '12px',
        padding: '20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '12px',
          color: 'var(--primary)',
          fontSize: '20px',
        }}
      >
        {icon}
        <span
          style={{
            fontSize: '16px',
            fontWeight: 600,
            color: 'var(--white)',
          }}
        >
          {title}
        </span>
      </div>

      <p
        style={{
          fontSize: '14px',
          color: 'var(--grey)',
          lineHeight: 1.5,
        }}
      >
        {description}
      </p>

      <div
        style={{
          marginTop: '12px',
          fontSize: '12px',
          color: 'var(--grey)',
          opacity: 0.8,
        }}
      >
        Category: {category}
      </div>
    </div>
  );
}